/*
* Check if the customer need the board individual, panelized tab routed
* or panelized v-scored
*/
import React, { useEffect } from 'react';
import RadioComponent from 'shared/components/RadioComponent';
import HiddenInput from 'shared/components/HiddenInput';

const HasArray = (props) => {
  const {
    parameters,
    onChangeParameter,
    groupName,
  } = props;

  const {
    has_array,
    tab_rout,
    scoring,
  } = parameters;

  useEffect(() => {
    if (jQuery('label.error:visible').length) {
      vfIsValidForQuote('#quote_form', false);
    }
  }, [has_array, tab_rout, scoring]);

  return (
    <div className="has-array-section itv">
      <strong className="title">I would like to receive my PCBs as</strong>
      <div className="row g-0 has-array">
        <div className="col-12">
          <RadioComponent
            name="has_array_temp"
            label="Individual Boards"
            value="0"
            checked={has_array === '0'}
            onChange={e => onChangeParameter('has_array', e.target.value)}
            className="individually"
            inputClassName="has-array-no"
            inputId="has-array-no"
            groupName={groupName} />
          <HiddenInput name="has_array" value={has_array} groupName={groupName} />
        </div>
        <div className="col-sm-6 col-lg-12 col-xl-6">
          <RadioComponent
            name="tab_route_panels"
            label="Tab Routed Panels"
            value="1"
            checked={has_array === '1' && tab_rout === '1'}
            onChange={() => onChangeParameter('tab_route_panels', '1')}
            className="tab-routed-panel"
            inputClassName="has-array-yes-tab-route"
            inputId="has-array-yes-tab-route"
            groupName={groupName} />
        </div>
        <div className="col-sm-6 col-lg-12 col-xl-6 ps-xl-2 ">
          <RadioComponent
            name="v_score_panels"
            label="V-Scored Panels"
            value="1"
            checked={has_array === '1' && scoring === '1'}
            onChange={() => onChangeParameter('v_score_panels', '1')}
            className="v-scored-panels"
            inputClassName="has-array-yes-scoring"
            inputId="has-array-yes-scoring"
            groupName={groupName} />
        </div>
      </div>
    </div>
  );
};

HasArray.defaultProps = {};

export default HasArray;
